export const PAGE_TYPE_CONTEXT = "PAGE_TYPE_CONTEXT";
export const PAGE_CTA_CONTEXT = "PAGE_CTA_CONTEXT";
export const PATH_CONTEXT = "PATH_CONTEXT";
export const PAGE_LANGUAGE = "PAGE_LANGUAGE";
